export const STORE_KEY = '@@checkout'
export const GET_CHECKOUT_META_REQUEST = `${STORE_KEY}/GET_CHECKOUT_META_REQUEST`
export const GET_CHECKOUT_META_SUCCESS = `${STORE_KEY}/GET_CHECKOUT_META_SUCCESS`
export const GET_CHECKOUT_META_FAILURE = `${STORE_KEY}/GET_CHECKOUT_META_FAILURE`
export const GET_CHECKOUT_PAYMENT_METHODS_REQUEST = `${STORE_KEY}/GET_CHECKOUT_PAYMENT_METHODS_REQUEST`
export const GET_CHECKOUT_PAYMENT_METHODS_SUCCESS = `${STORE_KEY}/GET_CHECKOUT_PAYMENT_METHODS_SUCCESS`
export const GET_CHECKOUT_PAYMENT_METHODS_FAILURE = `${STORE_KEY}/GET_CHECKOUT_PAYMENT_METHODS_FAILURE`
export const GET_PAYMENT_TOKEN_REQUEST = `${STORE_KEY}/GET_PAYMENT_TOKEN_REQUEST`
export const GET_PAYMENT_TOKEN_SUCCESS = `${STORE_KEY}/GET_PAYMENT_TOKEN_SUCCESS`
export const GET_PAYMENT_TOKEN_FAILURE = `${STORE_KEY}/GET_PAYMENT_TOKEN_FAILURE`
export const CHECKOUT_REQUEST = `${STORE_KEY}/CHECKOUT_REQUEST`
export const CHECKOUT_SUCCESS = `${STORE_KEY}/CHECKOUT_SUCCESS`
export const CHECKOUT_FAILURE = `${STORE_KEY}/CHECKOUT_FAILURE`
export const UPDATE_DELIVERY_DETAILS_REQUEST = `${STORE_KEY}/UPDATE_DELIVERY_DETAILS_REQUEST`
export const UPDATE_DELIVERY_DETAILS_SUCCESS = `${STORE_KEY}/UPDATE_DELIVERY_DETAILS_SUCCESS`
export const UPDATE_DELIVERY_DETAILS_FAILURE = `${STORE_KEY}/UPDATE_DELIVERY_DETAILS_FAILURE`
export const GET_STORE_ORDER_META_DATA_REQUEST = `${STORE_KEY}/GET_STORE_ORDER_META_DATA_REQUEST`
export const GET_STORE_ORDER_META_DATA_SUCCESS = `${STORE_KEY}/GET_STORE_ORDER_META_DATA_SUCCESS`
export const GET_STORE_ORDER_META_DATA_FAILURE = `${STORE_KEY}/GET_STORE_ORDER_META_DATA_FAILURE`
export const GET_LIST_OF_VOUCHERS_REQUEST = `${STORE_KEY}/GET_LIST_OF_VOUCHERS_REQUEST`
export const GET_LIST_OF_VOUCHERS_SUCCESS = `${STORE_KEY}/GET_LIST_OF_VOUCHERS_SUCCESS`
export const GET_LIST_OF_VOUCHERS_FAILURE = `${STORE_KEY}/GET_LIST_OF_VOUCHERS_FAILURE`
export const REMOVE_SELECTED_VOUCHER = `${STORE_KEY}/REMOVE_SELECTED_VOUCHER`
export const SET_SELECTED_VOUCHER = `${STORE_KEY}/SET_SELECTED_VOUCHER`
export const VALIDATE_VOUCHER_REQUEST = `${STORE_KEY}/VALIDATE_VOUCHER_REQUEST`
export const VALIDATE_VOUCHER_SUCCESS = `${STORE_KEY}/VALIDATE_VOUCHER_SUCCESS`
export const VALIDATE_VOUCHER_FAILURE = `${STORE_KEY}/VALIDATE_VOUCHER_FAILURE`
export const STORE_CHECKOUT_ADDRESS_INFO = `${STORE_KEY}/STORE_CHECKOUT_ADDRESS_INFO`
export const SELECTED_SAVED_CREDIT_CARD = `${STORE_KEY}/SELECTED_SAVED_CREDIT_CARD`
export const UPDATE_CHECKOUT_META_SUCCESS = `${STORE_KEY}/UPDATE_CHECKOUT_META_SUCCESS`
export const UPDATE_CHECKOUT_META_REQUEST = `${STORE_KEY}/UPDATE_CHECKOUT_META_REQUEST`
export const UPDATE_CHECKOUT_META_FAILURE = `${STORE_KEY}/UPDATE_CHECKOUT_META_FAILURE`
